/**
 * Fixed, non-configurable aging buckets for the A/R Aging Summary + Detail
 * reports. Order and labels are exact per the PRD — never reuse the
 * Invoicing tab's 4-bucket `InvoiceDueDateSubsegment` (that one collapses
 * 61+ and is `NOW()`-based, not as-of-D).
 */
export enum ArAgingBucket {
    CURRENT = "current",
    DAYS_1_TO_30 = "days_1_to_30",
    DAYS_31_TO_60 = "days_31_to_60",
    DAYS_61_TO_90 = "days_61_to_90",
    DAYS_91_AND_OVER = "days_91_and_over",
}

/** Exact display labels, in the fixed column/section order. */
export const AR_AGING_BUCKET_LABELS: Record<ArAgingBucket, string> = {
    [ArAgingBucket.CURRENT]: "Current",
    [ArAgingBucket.DAYS_1_TO_30]: "1-30",
    [ArAgingBucket.DAYS_31_TO_60]: "31-60",
    [ArAgingBucket.DAYS_61_TO_90]: "61-90",
    [ArAgingBucket.DAYS_91_AND_OVER]: "91+",
};

/** Fixed column/section order — always render/iterate in this exact order. */
export const AR_AGING_BUCKET_ORDER: ArAgingBucket[] = [
    ArAgingBucket.CURRENT,
    ArAgingBucket.DAYS_1_TO_30,
    ArAgingBucket.DAYS_31_TO_60,
    ArAgingBucket.DAYS_61_TO_90,
    ArAgingBucket.DAYS_91_AND_OVER,
];

export enum ArAgingDetailSource {
    INVOICE = "invoice",
    QUICKBOOKS = "quickbooks",
}
